<div class="container-box p-3">
  <div [class.loading-section]="(isLoadingConnections$ | async) || (isLoadingFacilities$ | async)">
    <ng-container *ngIf="showEvisitor; else noProviders">
      <div class="card p-3">
        <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
          <div class="me-3 flex-grow-1">
            <h6 class="text-uppercase mb-1" i18n>eVisitor (Croatia)</h6>
            <p class="text-muted small mb-0">
              <ng-container i18n>
                Connect this rental to Croatia's eVisitor to register and deregister guests directly from Tokeet.
              </ng-container>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>eVisitor Connection</mat-label>
              <mat-select
                [value]="selectedConnectionPkey"
                (selectionChange)="onConnectionSelected($event.value)"
                [disabled]="(isLoadingConnections$ | async) || !connections?.length"
              >
                <mat-option *ngFor="let connection of connections" [value]="connection.pkey">
                  {{ connection.configuration?.['username'] || connection.name || connection.pkey }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="!(isLoadingConnections$ | async) && !connections?.length" i18n
                >No connections found. Manage connections in Compliance.</mat-hint
              >
            </mat-form-field2>
          </div>
        </div>
        <ng-container *ngIf="selectedConnectionPkey">
          <ng-container *ngIf="matchedFacility">
            <div class="mt-3">
              <h6 class="text-uppercase small text-muted mb-2" i18n>Matched facility</h6>
              <div class="facility-card">
                <div>
                  <div class="fw-semibold">{{ matchedFacility?.name }}</div>
                  <div class="text-muted small">ID: {{ matchedFacility?.id }}</div>
                  <div class="text-muted small" *ngIf="matchedFacility?.address || matchedFacility?.city">
                    {{ matchedFacility?.address }}
                    <span *ngIf="matchedFacility?.city">&middot; {{ matchedFacility?.city }}</span>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-secondary-primary btn-sm"
                  (click)="onUnlinkFacility()"
                  [disabled]="isLinking$ | async"
                >
                  <ng-container i18n>Unlink</ng-container>
                </button>
              </div>
            </div>
          </ng-container>
          <div class="mt-3" *ngIf="!matchedFacility">
            <h6 class="text-uppercase small text-muted mb-2" i18n>Facilities</h6>
            <div class="facility-filters d-flex flex-wrap gap-2 mb-2">
              <mat-form-field2 class="facility-filter">
                <mat-label i18n>Search facilities</mat-label>
                <input
                  matInput
                  [formControl]="facilitySearchCtrl"
                  i18n-placeholder
                  placeholder="Search by name, ID, address"
                />
              </mat-form-field2>
            </div>
            <ng-container *ngIf="facilities.length; else noFacilitiesFound">
              <div class="facility-list">
                <div class="facility-row" *ngFor="let facility of filteredFacilities">
                  <div class="facility-info">
                    <div class="fw-semibold">{{ facility.name }}</div>
                    <div class="text-muted small">ID: {{ facility.id }}</div>
                    <div class="text-muted small" *ngIf="facility.address || facility.city">
                      {{ facility.address }} <span *ngIf="facility.city">&middot; {{ facility.city }}</span>
                    </div>
                  </div>
                  <div class="facility-action">
                    <ng-container *ngIf="facility.id === matchedFacility?.id; else linkAction">
                      <span class="badge bg-success facility-status" i18n>Linked</span>
                    </ng-container>
                    <ng-template #linkAction>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        (click)="onLinkFacility(facility)"
                        [disabled]="isLinking$ | async"
                        i18n
                      >
                        Link Facility
                      </button>
                    </ng-template>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noFacilitiesFound>
              <div class="alert alert-warning mb-0" role="alert">
                <i class="far fa-exclamation-circle me-2"></i>
                <ng-container i18n>No facilities available for this connection.</ng-container>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #noProviders>
      <div class="alert alert-info mb-0" role="alert">
        <i class="far fa-info-circle me-2"></i>
        <ng-container i18n>
          No compliance providers are available for this rental. Compliance integrations are available for rentals in
          specific countries.
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>
